import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';

export const settingsReasonsConfig = {
    stockmutations:  {
        title: 'stock_mutations',
        icon: <PlaylistAddIcon/>,
        isSingleDataGrid: true,
    },
    return:  {
        title: 'returns',
        icon: <PlaylistAddIcon/>,
        isSingleDataGrid: true,
    },
};
